package com.speedsoftware.nibbler.ui.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect

// Implemented in login-form.js, which builds a real <form> so browser password managers can save and fill it.
private fun bridge(): dynamic = js("window.NibblerLoginForm")

actual fun isNativeLoginFormAvailable(): Boolean = js("typeof window.NibblerLoginForm !== 'undefined'") as Boolean

@Composable
actual fun NativeLoginForm(flow: LoginFlow, onInvite: (String) -> Unit, onForgotPassword: () -> Unit) {
    DisposableEffect(Unit) {
        val config = js("({})")
        config.serverUrl = flow.serverUrl
        config.onCredentials = { email: String, password: String, server: String -> flow.submitCredentials(email, password, server) }
        config.onCode = { code: String -> flow.submitCode(code) }
        config.onBack = { flow.backToCredentials() }
        config.onInvite = { token: String -> onInvite(token) }
        config.onForgotPassword = { onForgotPassword() }
        bridge().mount(config)
        flow.onLoggedIn = { bridge().loggedIn() }
        onDispose {
            flow.onLoggedIn = null
            bridge().unmount()
        }
    }

    LaunchedEffect(flow.step, flow.isLoading, flow.errorMessage) {
        bridge().update(flow.step.name, flow.isLoading, flow.errorMessage ?: "")
    }
}
